import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material/";
import { useTranslation } from "react-i18next";
import actions from "../../Store/actions";
import { strings } from "../../common/i18n";

export default () => {
    const { auth } = useSelector((state) => state);
    const dispatch = useDispatch();
    const { i18n } = useTranslation();
    const selectedLanguage = localStorage.getItem("cvControllerLang")
        ? localStorage.getItem("cvControllerLang")
        : "en";
    const [language, setLanguage] = useState(selectedLanguage);
    const handleChange = (event) => setLanguage(event.target.value);

    useEffect(() => {
        const selectedLang = selectedLanguage ? selectedLanguage : language;
        if (selectedLang) {
            setLanguage(selectedLang);
        }
    }, [selectedLanguage]);

    const onLangaugeChange = async (event) => {
        const value = event.target.value;
        setLanguage(value);
        i18n.changeLanguage(value);

        const detail = {
            userId: auth.account.id,
            languageCode: value
        };

        await dispatch(actions.userLanguage.create.postRequest(detail));
        localStorage.setItem("cvControllerLang", value);
        window.location.reload();
    };

    return (
        <>
            <FormControl sx={{ m: 1, minWidth: 80 }}>
                <InputLabel id="demo-simple-select-autowidth-label">
                    {strings("language")}
                </InputLabel>
                <Select
                    labelId="demo-simple-select-autowidth-label"
                    id="demo-simple-select-autowidth"
                    value={language}
                    onChange={onLangaugeChange}
                    autoWidth
                    label="language"
                >
                    <MenuItem value="en">{strings("english")}</MenuItem>
                    <MenuItem value="fr">{strings("french")}</MenuItem>
                    <MenuItem value="es">{strings("spanish")}</MenuItem>
                    <MenuItem value="it">{strings("italian")}</MenuItem>
                </Select>
            </FormControl>
        </>
    );
};
